import {UpdateAction, TaskUpdateType, UpdateType} from "../../types"

export default function createUpdateAction(updateType: TaskUpdateType | UpdateType, payload: any): UpdateAction {
    return {
        updateType,
        payload
    }
}